import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export function normalizeLocationText(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

export async function fetchLimaDistrictCatalog() {
  const { data } = await axios.get(`${API_URL}/api/catalog/lima-districts`);
  return data.items || [];
}

export function isAfternoonOnlyDistrict(districtName, districts = []) {
  const needle = normalizeLocationText(districtName);
  if (!needle) return false;

  return districts.some((district) => {
    const values = [
      district.name,
      district.slug,
      ...(district.aliases || []),
    ].map(normalizeLocationText);

    return Boolean(district.afternoon_only && values.includes(needle));
  });
}
